module.exports = __webpack_public_path__ + "img/ymjj.9bd365a7.png";